import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { JSX } from 'react';
import { FC } from 'react';
import { isDevelopment, isLocal } from 'utils';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export const ReactQueryProvider: FC<{ children: JSX.Element }> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    {children}
    {(isDevelopment() || isLocal()) && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);
